import { render, staticRenderFns } from "./SayfaListesi.vue?vue&type=template&id=3093aea3&scoped=true&"
import script from "./SayfaListesi.vue?vue&type=script&lang=js&"
export * from "./SayfaListesi.vue?vue&type=script&lang=js&"
import style0 from "./SayfaListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SayfaListesi.vue?vue&type=style&index=1&id=3093aea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3093aea3",
  null
  
)

export default component.exports